import React, { useState } from "react"
import { Link } from "react-router-dom"
import { useDispatch } from "react-redux"
import { ReactComponent as LogoIcon } from "../../../icons/bandnada-logo.svg"
import { openAuthDialog } from "../../Authentication"
import NavLink from "./NavLink"
import UserMenu from "./UserMenu"
import ScenePicker from "./ScenePicker"
import SearchField from "./SearchField"
import { ShareBandNadaModal } from "../ShareBandNadaModal"
import { discover_path, root_path } from "../../../routes"

const Header = ({ user = null, query = "", standAlone = false }) => {
  const dispatch = useDispatch()
  const [showShareModal, setShowShareModal] = useState(false)

  return (
    <header className="w-full xl:fixed bg-white top-0 z-20">
      <div className="xl:grid xl:grid-cols-18 flex flex-wrap justify-between sm:items-center border-b-2 border-black bg-white z-10 py-3 px-3 xl:px-4">
        <div className="xl:col-span-6 mt-2 xl:mt-0">
          <div className="flex items-start">
            <div>
              {standAlone ? (
                <a href={root_path()}>
                  <LogoIcon className="h-6" />
                  {/* The logo SVG spells "bandNada" as vector paths, not real
                      text, so search engines and screen readers can't read
                      it from the graphic alone - this text node is the
                      crawlable/accessible equivalent. */}
                  <span className="sr-only">bandNada</span>
                </a>
              ) : (
                <Link to={root_path()}>
                  <LogoIcon className="h-6" />
                  <span className="sr-only">bandNada</span>
                </Link>
              )}
              <div className="font-semibold leading-none lowercase mt-0.5 text-gray-600 text-xs tracking-wide">
                the local music network
              </div>
            </div>
            <ScenePicker user={user} />
          </div>
        </div>

        <div className="xl:col-span-7 w-full order-3 xl:!order-none mt-4 xl:mt-0 relative">
          {!standAlone && <SearchField query={query} />}
        </div>

        {user ? (
          <nav className="xl:col-span-5 flex justify-end items-center">
            <NavLink
              className="hidden sm:block leading-none"
              path={discover_path()}
              content="Discover"
            />

            <button
              type="button"
              className="hidden sm:block leading-none px-3 lg:px-4 py-2 focus:outline-none text-black-800 hover:text-green-700"
              onClick={() => setShowShareModal(true)}
              aria-label="Share bandNada"
            >
              Share bandNada
            </button>

            <UserMenu user={user} />

            <ShareBandNadaModal
              isOpen={showShareModal}
              onDismiss={() => setShowShareModal(false)}
            />
          </nav>
        ) : (
          <nav className="xl:col-span-5 flex justify-between sm:justify-end items-center w-full sm:w-auto">
            <NavLink
              className="leading-none !px-0 sm:!px-3 lg:!px-4"
              path={discover_path()}
              content="Discover"
            />
            <button
              className="leading-none !px-0 sm:!px-3 lg:!px-4 py-2 font-bold text-black-800 focus:outline-none hover:text-green-700 cursor-pointer"
              onClick={() => dispatch(openAuthDialog())}
            >
              Sign Up / Log In
            </button>
          </nav>
        )}
      </div>
    </header>
  )
}

export default Header
